import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Badge from "@mui/material/Badge";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import MDButton from "components/MDButton";
import { Tooltip, IconButton, Modal, Typography, Select, MenuItem } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from '@mui/icons-material/Add'

import { AbilityContext } from "Can";
import { useAbility } from "@casl/react";
import DataTable from "examples/Tables/DataTable";
import DataGridTable from "examples/Tables/DataGridTable";
import crudsService from "services/cruds-service";
import ContactDeviceAccessDeviceView from "cruds/common/contactDeviceAccessDeviceView";
import { toast } from "react-toastify";
import NewUserModal from "cruds/modals/new-user";
import authService from "services/auth-service";

function ModalSelectContact({ open, setOpen, contacts, selectedContacts, setSelectedContacts, entityAddressItemList, entityId }) {
  let { state } = useLocation();
  const ability = useAbility(AbilityContext);
  const [tableData, setTableData] = useState([]);
  const [notification, setNotification] = useState({
    value: false,
    text: "",
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [tempselectedDevices, setTempSelectedDevices] = useState([])
  const [selectedThreRows, setSelectedThreRows] = useState([]);
  const [contactDeviceAccessList, setContactDeviceAccessList] = useState({})
  const [openContact, setOpenContact] = useState(false)
  const selectedContactId = useRef(null)
  const [openUserModal, setOpenUserModal] = useState(false)
  const [selectedContact, setSelectedContact] = useState({
    id: '',
    email: '',
    phone: '',
  })
  const [role, setRole] = useState('')
  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    organization: '',
    role: '',
  })
  const [contactName, setContactName] = useState('')

  const setUserCallback = useCallback(
    (newUser) => {
      setUser(newUser)
    },
    [setUser],
  )


  useEffect(() => {
    if (!state) return;
    setNotification({
      value: state.value,
      text: state.text,
    });
  }, [state]);

  useEffect(() => {
    const selectedIds = selectedContacts.map((contact) => contact.attributes?.contact_id);
    setSelectedRows(selectedIds);
  }, [selectedContacts]);

  useEffect(() => {
    setTableData(getRows(selectedContacts));
  }, [selectedContacts]);

  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  const clickDeleteHandler = (index) => {
    const indexToRemove = selectedContacts.findIndex(contact => contact?.attributes?.contact_id === index);
    if (indexToRemove !== -1) {
      // If the index is found (i.e., not -1), create a copy of the array and remove the element
      const updatedContacts = [...selectedContacts];
      updatedContacts.splice(indexToRemove, 1);
      setSelectedContacts(updatedContacts);
    } else {
      console.error(`Element with id not found.`);
    }

  };

  const clickAccessHandler = async (val, original_value) => {
    try {
      selectedContactId.current = val
      setContactName('')
      let addressItemIds = entityAddressItemList.map((e) => e.address_item_id)
      setDeviceList(entityAddressItemList)
      let response = await crudsService.getContactsAccessFromContact(val, addressItemIds)
      if (response.status === 'success') {
        let list = response.data.reduce((acc, val) => {
          acc[val.address_item_id] = {access_type: val?.access_type, service_access_type: val?.service_access_type}
          return acc;
        }, {})
        setContactDeviceAccessList(list);
        let addressItemsIds = response.data.map((e) => e.address_item_id)
        setSelectedThreRows(addressItemsIds)
        setContactName(original_value?.first_name + ' ' + original_value?.last_name)
      }
      setOpenContact(true)
    } catch (error) {
      console.error('Click access handler', error)
    }
  }

  useEffect(() => {
    let selectedContacts = deviceList.filter((e) => selectedThreRows.includes(e.address_item_id))
    selectedContacts = selectedContacts.map((e, i) => ({
      ...e,
      access_type: contactDeviceAccessList[e.address_item_id]?.access_type ?? 'read',
      service_access_type: contactDeviceAccessList[e.address_item_id]?.service_access_type ?? 'read',
    }))
    setTempSelectedDevices(selectedContacts)
  }, [selectedThreRows])

  const contactAccessHandler = async () => {
    try {
      let processPayload = tempselectedDevices.map((val) => ({
        contact_id: selectedContactId.current,
        address_item_id: val.address_item_id,
        access_type: val?.access_type,
        service_access_type: val?.service_access_type,
      }))
      let payload = {
        contact_id: selectedContactId.current,
        entity_id: Number(entityId),
        payload: processPayload
      }

      let resp = await crudsService.upsertContactDeviceAccess(payload)
      if (resp.success) {
        toast.success(resp.msg)
      }
      setOpenContact(false)
    } catch (error) {
      console.error('error', error)
      toast.error(error.error)
    }
  }
  const clickCreateUserHandler = async (id, email, phone) => {
    const response = await authService.getProfile()
    setRole('')
    setUser({
      name: '',
      email: '',
      phone: '',
      organization: response.data.attributes.Organization?.name,
      role: '',
    })

    setOpenUserModal(true)
    setSelectedContact({ id: id, email: email, phone: phone })
  }
  const handleUserModalClose = () => {
    setOpenUserModal(false)
  }

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      let phone = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 1 && contact.is_default === true);
      let email = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 2 && contact.is_default === true);
      let fax = row?.attributes?.ContactAddresses.find(contact => contact.address_type_id === 3 && contact.is_default === true);
      return {
        // StatusType: row.attributes?.StatusOption,
        status_badge: (
          <Badge
            color={row.attributes?.StatusOption?.BadgeDetail?.color || 'primary'}
            variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
            badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
            style={{ marginLeft: '30px' }}
          >
          </Badge>
        ),
        status: row.attributes?.StatusOption,
        type: "contacts",
        id: row.attributes?.contact_id,
        first_name: row.attributes?.first_name,
        last_name: row.attributes?.last_name,
        type: row.attributes?.ContactType?.type_name,
        phone: phone ? phone.contact_address : '', // Render phone.contact_address if phone exists, otherwise an empty string
        email: email ? email.contact_address : '', // Render email.contact_address if email exists, otherwise an empty string
        fax: fax ? fax.contact_address : '',
      };
    });
    return updatedInfo;
  };

  const dataTableData = {
    columns: [
      { Header: "Status", accessor: "status_badge", width: "15%" },
      { Header: "First Name", accessor: "first_name", width: "15%" },
      { Header: "Last Name", accessor: "last_name", width: "15%" },
      { Header: "Type", accessor: "type", width: "20%" },
      { Header: "Phone", accessor: "phone", width: "15%" },
      { Header: "Email", accessor: "email", width: "15%" },
      { Header: "Fax", accessor: "fax", width: "15%" },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              <Tooltip title="Edit Access">
                <IconButton onClick={(e) => clickAccessHandler(info.cell.row.original.id, info.cell.row.original)}>
                  <MDTypography><EditIcon /></MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Contact">
                <IconButton onClick={(e) => clickDeleteHandler(info.cell.row.original.id)}>
                  <MDTypography><DeleteIcon /></MDTypography>
                </IconButton>
              </Tooltip>
              <Tooltip title="Create User">
                <IconButton
                  onClick={() =>
                    clickCreateUserHandler(
                      info.cell.row.original.id,
                      info.cell.row.original.email,
                      info.cell.row.original.phone,
                    )
                  }
                >
                  <MDTypography>
                    <AddIcon />
                  </MDTypography>
                </IconButton>
              </Tooltip>
            </MDBox>
          );
        },
      },
    ],

    rows: tableData,
  };

  const dataTableAllData = {
    columns: [
      {
        headerName: "Status", field: "status", flex: 1,
        renderCell: (info) => {
          return <Badge
            color={info.value?.BadgeDetail?.color || 'primary'}
            variant={info.value?.BadgeDetail?.variant}
            badgeContent={info.value?.StatusType?.status_name}
            style={{ marginLeft: '30px' }}
          >
          </Badge>
        }
      },
      { headerName: "Type", field: "type", flex: 1 },
      { headerName: "Id", field: "id", flex: 1 },
      { headerName: "First Name", field: "first_name", flex: 1 },
      { headerName: "Last Name", field: "last_name", flex: 1 },
      { headerName: "Phone", field: "phone", flex: 1 },
      { headerName: "Email", field: "email", flex: 1 },
      { headerName: "Fax", field: "fax", flex: 1 },
    ],

    rows: getRows(contacts),
  };

  const handleClose = () => {
    setOpen(false);
  };

  const addressHandler = () => {
    // setAddresses([...addresses, newAddress]);
    const filteredAddresses = contacts.filter(address => selectedRows.includes(address.id));
    setSelectedContacts(filteredAddresses);
    // setSelectedContacts(prevSelectedContacts => [...prevSelectedContacts, ...filteredAddresses]);

    setOpen(false);
  };
  const removeList = (index) => {
    const updatedContactList = [...tempselectedDevices]
    updatedContactList.splice(index, 1)
    setTempSelectedDevices(updatedContactList)
  }
  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const updatedDataTable = [...tempselectedDevices];
    updatedDataTable[index].access_type = value;
    setTempSelectedDevices(updatedDataTable);
  };
  const handleServiceChange = (index, event) => {
    const { name, value } = event.target;
    const updatedDataTable = [...tempselectedDevices];
    updatedDataTable[index].service_access_type = value;
    setTempSelectedDevices(updatedDataTable);
  };
  const getRowsForContact = () => {
    return tempselectedDevices.map((row, index) => {
      const fields = [
        {
          address_item_id: row?.address_item_id
        },
        {
          name: row?.name
        },
        {
          itemName: row?.itemName
        },
      ];

      fields.push(
        {
          access_type: (
            <Select label="Access Type" name="access_type" value={row.access_type ?? 'read'} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
              <MenuItem key={'read'} value={'read'}>Read</MenuItem>
              <MenuItem key={'write'} value={'write'}>Write</MenuItem>
            </Select>
          ),
          service_access_type: (
            <Select label="Service Access Type" name="service_access_type" value={row.service_access_type ?? 'read'} onChange={(e) => handleServiceChange(index, e)} sx={{ height: '40px' }} required>
              <MenuItem key={'read'} value={'read'}>Read</MenuItem>
              <MenuItem key={'write'} value={'write'}>Write</MenuItem>
            </Select>
          ),
        }
      );
      return Object.assign({}, ...fields);
    });
  };
  const tableThresholdData = {
    columns: [
      { Header: "Address Item ID", accessor: "address_item_id" },
      { Header: "Name", accessor: "name" },
      { Header: "Item Name", accessor: "itemName" },
      { Header: "Access Type", accessor: "access_type" },
      { Header: "Service Access Type", accessor: "service_access_type" },
      {
        Header: "actions",
        disableSortBy: true,
        accessor: "",
        Cell: (info) => {
          return (
            <MDBox display="flex" alignItems="center">
              {(
                <Tooltip title="Delete Parameter">
                  <IconButton onClick={() => removeList(info.cell.row.index)}>
                    <MDTypography><DeleteIcon /></MDTypography>
                  </IconButton>
                </Tooltip>
              )}
            </MDBox>
          );
        },
      }
    ],
    rows: getRowsForContact(),
  };

  return (
    <MDBox>
      <Card>
        <MDBox>
          <NewUserModal
            role={role}
            setRole={setRole}
            user={user}
            setUser={setUserCallback}
            contact={selectedContact}
            open={openUserModal}
            handleClose={handleUserModalClose}
          />
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Card
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%', // Set the desired width here
                backgroundColor: 'white',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
              }}
            >
              {/* <MDBox p={3} lineHeight={1} display="flex" justifyContent="space-between">
                  <MDTypography variant="h5" fontWeight="medium">
                    Contact Management
                  </MDTypography>
                </MDBox> */}
              {/* <MultiSelectDataTable table={dataTableAllData} selectedRows={selectedRows} setSelectedRows={setSelectedRows}/> */}
              {/* <DataTable table={dataTableAllData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} isSelection={true} canSearch={true}/> */}
              <DataGridTable title="Contact Management" rowData={getRows(contacts)} columns={dataTableAllData.columns} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />
              <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                <MDButton variant="contained" color="secondary" onClick={handleClose}>
                  Cancel
                </MDButton>
                <MDButton variant="contained" color="info" onClick={addressHandler} style={{ marginLeft: '10px' }}>
                  Save
                </MDButton>
              </MDBox>
            </Card>
          </Modal>
          <Modal
            open={openContact}
            onClose={() => setOpenContact(false)}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Card
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%', // Set the desired width here
                backgroundColor: 'white',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
              }}
            >
              <ContactDeviceAccessDeviceView contactName={contactName} devices={deviceList} selectedDevices={selectedThreRows} setSelectedDevices={setSelectedThreRows} />
              <DataTable table={tableThresholdData} canSearch={true} tableHeight="calc(100vh - 410px)" />
              <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                <MDButton variant="contained" color="secondary" onClick={() => setOpenContact(false)}>
                  Cancel
                </MDButton>
                <MDButton variant="contained" color="info" onClick={contactAccessHandler} style={{ marginLeft: '10px' }}>
                  Save
                </MDButton>
              </MDBox>
            </Card>
          </Modal>
        </MDBox>
      </Card>
      {
        selectedContacts.length > 0 &&
        <MDBox mt={2}>
          <MDTypography ml={3}>Selected Contact(s)</MDTypography>
          <DataTable table={dataTableData} />
        </MDBox>
      }

    </MDBox>
  );
}

export default ModalSelectContact;
